export const DeeplinkRoutes = {
	Deeplink: '/dlink/:id',
};
